<template>
  <div class="yxtbiz-voice">
    <div class='yxtbizf-speech-container'>
      <div class='yxtbizf-speech bg-primary-6 color-primary-6 mr16'>
        <div class="mr12" v-show="isPlay" style="width:16px; height:16px" ref="container"></div>
        <yxt-svg  v-show="!isPlay" :remote-url='mediaPath' iconClass="voice" class="mr12" width="16px" height="16px"></yxt-svg>
        <span class='font-size-14 color-white'>{{text}}</span>
      </div>
      <span class='color-gray-7 font-size-14'><slot></slot>''</span>
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web';
import * as animationData from './data.json';
import bizSvg from 'yxt-biz-pc/src/mixins/bizSvg';
import { i18n } from '../../common-util/changeLangs';

export default {
  name: 'YxtbizVoice',
  mixins: [bizSvg],
  data() {
    return {
      defaultOptions: {animationData: animationData.default}
    };
  },
  props: {
    isPlay: {
      type: Boolean,
      default: false
    },
    text: {
      type: [String, Number],
      default: function() {
        return i18n.t('biz_click_to_listen_btn');
      }
    }
  },
  mounted() {
    lottie.loadAnimation({
      container: this.$refs.container,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: animationData.default
    });
  },
  methods: {
    handleClick() {
      this.isPlay = !this.isPlay;
    },
    handleAnimation(anim) {
      this.anim = anim;
    },
    stop() {
      this.anim.stop();
    },

    play() {
      this.anim.play();
    },
    pause() {
      this.anim.pause();
    }
  }
};
</script>
